"use strict";

var _createForOfIteratorHelper = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _assertThisInitialized = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/assertThisInitialized");

var _inherits = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _createSuper = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createSuper");

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var Document = require("../generated/Document");

var DocumentFragment = require("../generated/DocumentFragment");

var _require = require("../helpers/internal-constants"),
    cloningSteps = _require.cloningSteps,
    domSymbolTree = _require.domSymbolTree;

var _require2 = require("../node"),
    clone = _require2.clone;

var HTMLTemplateElementImpl = /*#__PURE__*/function (_HTMLElementImpl) {
  _inherits(HTMLTemplateElementImpl, _HTMLElementImpl);

  var _super = _createSuper(HTMLTemplateElementImpl);

  function HTMLTemplateElementImpl(args, privateData) {
    var _this;

    _classCallCheck(this, HTMLTemplateElementImpl);

    _this = _super.call(this, args, privateData);

    var doc = _this._appropriateTemplateContentsOwnerDocument(_this._ownerDocument);

    _this._templateContents = DocumentFragment.createImpl([], {
      ownerDocument: doc,
      host: _assertThisInitialized(_this)
    });
    return _this;
  } // https://html.spec.whatwg.org/multipage/scripting.html#appropriate-template-contents-owner-document


  _createClass(HTMLTemplateElementImpl, [{
    key: "_appropriateTemplateContentsOwnerDocument",
    value: function _appropriateTemplateContentsOwnerDocument(doc) {
      if (!doc._isInertTemplateDocument) {
        if (doc._associatedInertTemplateDocument === undefined) {
          var newDoc = Document.createImpl([], {
            options: {
              parsingMode: doc._parsingMode,
              encoding: doc._encoding
            }
          });
          newDoc._isInertTemplateDocument = true;
          doc._associatedInertTemplateDocument = newDoc;
        }

        doc = doc._associatedInertTemplateDocument;
      }

      return doc;
    } // https://html.spec.whatwg.org/multipage/scripting.html#template-adopting-steps

  }, {
    key: "_adoptingSteps",
    value: function _adoptingSteps() {
      var doc = this._appropriateTemplateContentsOwnerDocument(this._ownerDocument);

      doc._adoptNode(this._templateContents);
    }
  }, {
    key: cloningSteps,
    value: function value(copy, node, document, cloneChildren) {
      if (!cloneChildren) {
        return;
      }

      var _iterator = _createForOfIteratorHelper(domSymbolTree.childrenIterator(node._templateContents)),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var child = _step.value;
          var childCopy = clone(child, copy._templateContents._ownerDocument, true);

          copy._templateContents.appendChild(childCopy);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "content",
    get: function get() {
      return this._templateContents;
    }
  }]);

  return HTMLTemplateElementImpl;
}(HTMLElementImpl);

module.exports = {
  implementation: HTMLTemplateElementImpl
};